import React from 'react';
import BaseQuestionnaire from './BaseQuestionnaire';

const SpiritualGiftsQuestionnaire = () => {
  return (
    <BaseQuestionnaire>
      {({
        questionnaireConfig,
        currentQuestions,
        currentPage,
        answers,
        handleAnswerChange,
        QUESTIONS_PER_PAGE,
      }) => (
        <>
          {/* Questions Container */}
          <div className="questions-container">
            {currentQuestions.map((question, index) => {
              const globalIndex = currentPage * QUESTIONS_PER_PAGE + index;
              return (
                <div key={globalIndex} id={`question-${globalIndex}`} className="question-card">
                  <div className="question-text">
                    <strong>Question {globalIndex + 1}:</strong> {question.texte_question}
                  </div>
                  <div className="answer-options">
                    {questionnaireConfig.scaleLabels.map((label, value) => (
                      <div key={value} className="answer-option">
                        <input
                          type="radio"
                          id={`q${globalIndex}_${value}`}
                          name={`question_${globalIndex}`}
                          value={value}
                          checked={answers[globalIndex] === value}
                          onChange={(e) => handleAnswerChange(index, e.target.value)}
                        />
                        <label htmlFor={`q${globalIndex}_${value}`}>
                          {label} ({value})
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Guide Section */}
          <div className="card" style={{ marginTop: '2rem' }}>
            <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>
              Guide de réponse
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {questionnaireConfig.scaleLabels.map((label, index) => (
                <div key={index}>
                  <strong>{label} ({index}):</strong> 
                  {index === 0 && ' Cette affirmation ne vous correspond pas du tout / jamais'}
                  {index === 1 && ' Cette affirmation vous correspond un peu / rarement'}
                  {index === 2 && ' Cette affirmation vous correspond bien / souvent'}
                  {index === 3 && ' Cette affirmation vous correspond parfaitement / la plupart du temps'}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </BaseQuestionnaire>
  );
};

export default SpiritualGiftsQuestionnaire;
